import Background from "./Background";
import "./PrivacyPolicy.css";
import Footer from "./Footer";
import { useState } from "react";

function PrivacyPolicy() {
  const [language, setLanguage] = useState("en");

  return (
    <>
      <Background />
      <Footer />
      <div
        style={{
          position: "absolute",
          backgroundColor: "rgba(0,0,0,0.5)",
          height: "40px",
          width: "80px",
          right: "80px",
          top: "50px",
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <span
          className="privacy-language-button"
          style={{
            color: "white",
            textShadow: "0px 0px 5px purple",
            fontSize: "22px",
            zIndex: "100",
          }}
          onClick={() => setLanguage("en")}
        >
          EN
        </span>
        <div style={{ border: "1px solid white", height: "80%" }}></div>
        <span
          className="privacy-language-button"
          style={{
            color: "white",
            textShadow: "0px 0px 5px purple",
            fontSize: "22px",
            zIndex: "100",
          }}
          onClick={() => setLanguage("de")}
        >
          DE
        </span>
      </div>
      <div className="privacy-policy">
        {language != "en" ? (
          <div className="content">
            <h1>Datenschutzerkl&auml;rung</h1>

            <h2>1) Einleitung und Kontaktdaten des Verantwortlichen</h2>

            <p>
              <b>1.1</b>&nbsp;Wir freuen uns, dass Sie unsere Website besuchen
              und bedanken uns f&uuml;r Ihr Interesse. Im Folgenden informieren
              wir Sie &uuml;ber den Umgang mit Ihren personenbezogenen Daten bei
              der Nutzung unserer Website. Personenbezogene Daten sind hierbei
              alle Daten, mit denen Sie pers&ouml;nlich identifiziert werden
              k&ouml;nnen.
            </p>

            <p>
              <b>1.2</b>&nbsp;Verantwortlicher f&uuml;r die Datenverarbeitung
              auf dieser Website im Sinne der Datenschutz-Grundverordnung
              (DSGVO) ist Norman Azar, GliaTech, Gro&szlig;gartacherstr. 90,
              74080 Heilbronn, Deutschland, Tel.: +491792235717, E-Mail:
              admin@gliatech.net. Der f&uuml;r die Verarbeitung von
              personenbezogenen Daten Verantwortliche ist diejenige
              nat&uuml;rliche oder juristische Person, die allein oder gemeinsam
              mit anderen &uuml;ber die Zwecke und Mittel der Verarbeitung von
              personenbezogenen Daten entscheidet.
            </p>

            <h2>2) Datenerfassung beim Besuch unserer Website</h2>

            <p>
              <b>2.1</b>&nbsp;Bei der blo&szlig; informatorischen Nutzung
              unserer Website, also wenn Sie sich nicht registrieren oder uns
              anderweitig Informationen &uuml;bermitteln, erheben wir nur solche
              Daten, die Ihr Browser an den Seitenserver &uuml;bermittelt (sog.
              &bdquo;Server-Logfiles&#8220;). Wenn Sie unsere Website aufrufen,
              erheben wir die folgenden Daten, die f&uuml;r uns technisch
              erforderlich sind, um Ihnen die Website anzuzeigen:
            </p>

            <ul>
              <li>Unsere besuchte Website</li>
              <li>Datum und Uhrzeit zum Zeitpunkt des Zugriffes</li>
              <li>Menge der gesendeten Daten in Byte</li>
              <li>Quelle/Verweis, von welchem Sie auf die Seite gelangten</li>
              <li>Verwendeter Browser</li>
              <li>Verwendetes Betriebssystem</li>
              <li>Verwendete IP-Adresse (ggf.: in anonymisierter Form)</li>
            </ul>

            <p>
              Die Verarbeitung erfolgt gem&auml;&szlig; Art. 6 Abs. 1 lit. f
              DSGVO auf Basis unseres berechtigten Interesses an der
              Verbesserung der Stabilit&auml;t und Funktionalit&auml;t unserer
              Website. Eine Weitergabe oder anderweitige Verwendung der Daten
              findet nicht statt. Wir behalten uns allerdings vor, die
              Server-Logfiles nachtr&auml;glich zu &uuml;berpr&uuml;fen, sollten
              konkrete Anhaltspunkte auf eine rechtswidrige Nutzung hinweisen.
            </p>

            <p>
              <b>2.2</b>&nbsp;Diese Website nutzt aus Sicherheitsgr&uuml;nden
              und zum Schutz der &Uuml;bertragung personenbezogener Daten und
              anderer vertraulicher Inhalte (z.B. Bestellungen oder Anfragen an
              den Verantwortlichen) eine SSL-bzw. TLS-Verschl&uuml;sselung. Sie
              k&ouml;nnen eine verschl&uuml;sselte Verbindung an der
              Zeichenfolge &bdquo;https://&#8220; und dem Schloss-Symbol in
              Ihrer Browserzeile erkennen.
            </p>

            <h2>3) Hosting &amp; Content-Delivery-Network</h2>

            <p>Google Cloud CDN</p>

            <p>
              Wir nutzen ein Content Delivery Network des folgenden Anbieters:
              Google Ireland Limited, Gordon House, 4 Barrow St, Dublin, D04
              E5W5, Irland
            </p>

            <p>
              Dieser Dienst erm&ouml;glicht uns, gro&szlig;e Mediendateien wie
              Grafiken, Seiteninhalte oder Skripte &uuml;ber ein Netz regional
              verteilter Server schneller auszuliefern. Die Verarbeitung erfolgt
              zur Wahrung unseres berechtigten Interesses an der Verbesserung
              der Stabilit&auml;t und Funktionalit&auml;t unserer Website gem.
              Art. 6 Abs. 1 lit. f DSGVO.
            </p>

            <p>
              Daten k&ouml;nnen zudem &uuml;bertragen werden an: Google LLC, USA
            </p>

            <p>
              Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag
              geschlossen, der den Schutz der Daten unserer Seitenbesucher
              sicherstellt und eine unberechtigte Weitergabe an Dritte
              untersagt.
            </p>

            <p>
              F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der Anbieter
              dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework)
              angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der
              Europ&auml;ischen Kommission die Einhaltung des europ&auml;ischen
              Datenschutzniveaus&nbsp;sicherstellt.
            </p>

            <h2>4) Cookies</h2>

            <p>
              Um den Besuch unserer Website attraktiv zu gestalten und die
              Nutzung bestimmter Funktionen zu erm&ouml;glichen, verwenden wir
              Cookies, also kleine Textdateien, die auf Ihrem Endger&auml;t
              abgelegt werden. Teilweise werden diese Cookies nach
              Schlie&szlig;en des Browsers automatisch wieder gel&ouml;scht
              (sog. &bdquo;Session-Cookies&#8220;), teilweise verbleiben diese
              Cookies l&auml;nger auf Ihrem Endger&auml;t und erm&ouml;glichen
              das Speichern von Seiteneinstellungen (sog. &bdquo;persistente
              Cookies&#8220;). Im letzteren Fall k&ouml;nnen Sie die
              Speicherdauer der &Uuml;bersicht zu den Cookie-Einstellungen Ihres
              Webbrowsers entnehmen.
            </p>

            <p>
              Sofern durch einzelne von uns eingesetzte Cookies auch
              personenbezogene Daten verarbeitet werden, erfolgt die
              Verarbeitung gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO entweder
              zur Durchf&uuml;hrung des Vertrages, gem&auml;&szlig; Art. 6 Abs.
              1 lit. a DSGVO im Falle einer erteilten Einwilligung oder
              gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO zur Wahrung unserer
              berechtigten Interessen an der bestm&ouml;glichen
              Funktionalit&auml;t der Website sowie einer kundenfreundlichen und
              effektiven Ausgestaltung des Seitenbesuchs.
            </p>

            <p>
              Sie k&ouml;nnen Ihren Browser so einstellen, dass Sie &uuml;ber
              das Setzen von Cookies informiert werden und einzeln &uuml;ber
              deren Annahme entscheiden oder die Annahme von Cookies f&uuml;r
              bestimmte F&auml;lle oder generell ausschlie&szlig;en k&ouml;nnen.
            </p>

            <p>
              Bitte beachten Sie, dass bei Nichtannahme von Cookies die
              Funktionalit&auml;t unserer Website eingeschr&auml;nkt sein kann.
            </p>

            <h2>5) Kontaktaufnahme</h2>

            <p>
              Im Rahmen der Kontaktaufnahme mit uns (z.B. per Kontaktformular
              oder E-Mail) werden personenbezogene Daten erhoben. Welche Daten
              im Falle der Nutzung eines Kontaktformulars erhoben werden, ist
              aus dem jeweiligen Kontaktformular ersichtlich. Diese Daten werden
              ausschlie&szlig;lich zum Zweck der Beantwortung Ihres Anliegens
              bzw. f&uuml;r die Kontaktaufnahme und die damit verbundene
              technische Administration gespeichert und verwendet.
            </p>

            <p>
              Rechtsgrundlage f&uuml;r die Verarbeitung dieser Daten ist unser
              berechtigtes Interesse an der Beantwortung Ihres Anliegens
              gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO. Zielt Ihre
              Kontaktierung auf den Abschluss eines Vertrages ab, so ist
              zus&auml;tzliche Rechtsgrundlage f&uuml;r die Verarbeitung Art. 6
              Abs. 1 lit. b DSGVO. Ihre Daten werden nach abschlie&szlig;ender
              Bearbeitung Ihrer Anfrage gel&ouml;scht. Dies ist der Fall, wenn
              sich aus den Umst&auml;nden entnehmen l&auml;sst, dass der
              betroffene Sachverhalt abschlie&szlig;end gekl&auml;rt ist und
              sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>

            <h2>6) Nutzung von Kundendaten zur Direktwerbung</h2>

            <p>Anmeldung zu unserem E-Mail-Newsletter</p>

            <p>
              Wenn Sie sich zu unserem E-Mail Newsletter anmelden,
              &uuml;bersenden wir Ihnen regelm&auml;&szlig;ig Informationen zu
              unseren Angeboten. Pflichtangabe f&uuml;r die &Uuml;bersendung des
              Newsletters ist allein Ihre E-Mailadresse. Die Angabe weiterer
              Daten ist freiwillig und wird verwendet, um Sie pers&ouml;nlich
              ansprechen zu k&ouml;nnen. F&uuml;r den Versand des Newsletters
              verwenden wir das sog. Double Opt-in Verfahren. Dies bedeutet,
              dass wir Ihnen erst dann einen E-Mail Newsletter &uuml;bermitteln
              werden, wenn Sie uns ausdr&uuml;cklich best&auml;tigt haben, dass
              Sie in den Empfang von Newsletter einwilligen. Wir schicken Ihnen
              dann eine Best&auml;tigungs-E-Mail, mit der Sie gebeten werden
              durch Anklicken eines entsprechenden Links zu best&auml;tigen,
              dass Sie k&uuml;nftig den Newsletter erhalten wollen.
            </p>

            <p>
              Mit der Aktivierung des Best&auml;tigungslinks erteilen Sie uns
              Ihre Einwilligung f&uuml;r die Nutzung Ihrer personenbezogenen
              Daten gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO. Bei der
              Anmeldung zum Newsletter speichern wir Ihre vom Internet
              Service-Provider (ISP) eingetragene IP-Adresse sowie das Datum und
              die Uhrzeit der Anmeldung, um einen m&ouml;glichen Missbrauch
              Ihrer E-Mail- Adresse zu einem sp&auml;teren Zeitpunkt
              nachvollziehen zu k&ouml;nnen. Die von uns bei der Anmeldung zum
              Newsletter erhobenen Daten werden ausschlie&szlig;lich f&uuml;r
              Zwecke der werblichen Ansprache im Wege des Newsletters benutzt.
              Sie k&ouml;nnen den Newsletter jederzeit &uuml;ber den daf&uuml;r
              vorgesehenen Link im Newsletter oder durch entsprechende Nachricht
              an den eingangs genannten Verantwortlichen abbestellen. Nach
              erfolgter Abmeldung wird Ihre E-Mailadresse unverz&uuml;glich in
              unserem Newsletter-Verteiler gel&ouml;scht, soweit Sie nicht
              ausdr&uuml;cklich in eine weitere Nutzung Ihrer Daten eingewilligt
              haben oder wir uns eine dar&uuml;berhinausgehende Datenverwendung
              vorbehalten, die gesetzlich erlaubt ist und &uuml;ber die wir Sie
              in dieser Erkl&auml;rung informieren.
            </p>

            <h2>7) Rechte des Betroffenen</h2>

            <p>
              <b>7.1</b>&nbsp;Das geltende Datenschutzrecht gew&auml;hrt Ihnen
              gegen&uuml;ber dem Verantwortlichen hinsichtlich der Verarbeitung
              Ihrer personenbezogenen Daten die nachstehenden Betroffenenrechte
              (Auskunfts- und Interventionsrechte), wobei f&uuml;r die
              jeweiligen Aus&uuml;bungsvoraussetzungen auf die angef&uuml;hrte
              Rechtsgrundlage verwiesen wird:
            </p>

            <ul>
              <li>Auskunftsrecht gem&auml;&szlig; Art. 15 DSGVO;</li>
              <li>Recht auf Berichtigung gem&auml;&szlig; Art. 16 DSGVO;</li>
              <li>Recht auf L&ouml;schung gem&auml;&szlig; Art. 17 DSGVO;</li>
              <li>
                Recht auf Einschr&auml;nkung der Verarbeitung gem&auml;&szlig;
                Art. 18 DSGVO;
              </li>
              <li>Recht auf Unterrichtung gem&auml;&szlig; Art. 19 DSGVO;</li>
              <li>
                Recht auf Daten&uuml;bertragbarkeit gem&auml;&szlig; Art. 20
                DSGVO;
              </li>
              <li>
                Recht auf Widerruf erteilter Einwilligungen gem&auml;&szlig;
                Art. 7 Abs. 3 DSGVO;
              </li>
              <li>Recht auf Beschwerde gem&auml;&szlig; Art. 77 DSGVO.</li>
            </ul>

            <p>
              <b>7.2</b>&nbsp;WIDERSPRUCHSRECHT
            </p>

            <p>
              WENN WIR IM RAHMEN EINER INTERESSENABW&Auml;GUNG IHRE
              PERSONENBEZOGENEN DATEN AUFGRUND UNSERES &Uuml;BERWIEGENDEN
              BERECHTIGTEN INTERESSES VERARBEITEN, HABEN SIE DAS JEDERZEITIGE
              RECHT, AUS GR&Uuml;NDEN, DIE SICH AUS IHRER BESONDEREN SITUATION
              ERGEBEN, GEGEN DIESE VERARBEITUNG WIDERSPRUCH MIT WIRKUNG F&Uuml;R
              DIE ZUKUNFT EINZULEGEN.
            </p>

            <p>
              MACHEN SIE VON IHREM WIDERSPRUCHSRECHT GEBRAUCH, BEENDEN WIR DIE
              VERARBEITUNG DER BETROFFENEN DATEN. EINE WEITERVERARBEITUNG BLEIBT
              ABER VORBEHALTEN, WENN WIR ZWINGENDE SCHUTZW&Uuml;RDIGE
              GR&Uuml;NDE F&Uuml;R DIE VERARBEITUNG NACHWEISEN K&Ouml;NNEN, DIE
              IHRE INTERESSEN, GRUNDRECHTE UND GRUNDFREIHEITEN &Uuml;BERWIEGEN,
              ODER WENN DIE VERARBEITUNG DER GELTENDMACHUNG, AUS&Uuml;BUNG ODER
              VERTEIDIGUNG VON RECHTSANSPR&Uuml;CHEN DIENT.
            </p>

            <p>
              WERDEN IHRE PERSONENBEZOGENEN DATEN VON UNS VERARBEITET, UM
              DIREKTWERBUNG ZU BETREIBEN, HABEN SIE DAS RECHT, JEDERZEIT
              WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER
              PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN.
              SIE K&Ouml;NNEN DEN WIDERSPRUCH WIE OBEN BESCHRIEBEN AUS&Uuml;BEN.
            </p>

            <p>
              MACHEN SIE VON IHREM WIDERSPRUCHSRECHT GEBRAUCH, BEENDEN WIR DIE
              VERARBEITUNG DER BETROFFENEN DATEN ZU DIREKTWERBEZWECKEN.
            </p>

            <h2>8) Dauer der Speicherung personenbezogener Daten</h2>

            <p>
              Die Dauer der Speicherung von personenbezogenen Daten bemisst sich
              anhand der jeweiligen Rechtsgrundlage, am Verarbeitungszweck und
              &ndash; sofern einschl&auml;gig &ndash; zus&auml;tzlich anhand der
              jeweiligen gesetzlichen Aufbewahrungsfrist (z.B. handels- und
              steuerrechtliche Aufbewahrungsfristen).
            </p>

            <p>
              Bei der Verarbeitung von personenbezogenen Daten auf Grundlage
              einer ausdr&uuml;cklichen Einwilligung gem&auml;&szlig; Art. 6
              Abs. 1 lit. a DSGVO werden die betroffenen Daten so lange
              gespeichert, bis Sie Ihre Einwilligung widerrufen.
            </p>

            <p>
              Existieren gesetzliche Aufbewahrungsfristen f&uuml;r Daten, die im
              Rahmen rechtsgesch&auml;ftlicher bzw.
              rechtsgesch&auml;fts&auml;hnlicher Verpflichtungen auf der
              Grundlage von Art. 6 Abs. 1 lit. b DSGVO verarbeitet werden,
              werden diese Daten nach Ablauf der Aufbewahrungsfristen
              routinem&auml;&szlig;ig gel&ouml;scht, sofern sie nicht mehr zur
              Vertragserf&uuml;llung oder Vertragsanbahnung erforderlich sind
              und/oder unsererseits kein berechtigtes Interesse an der
              Weiterspeicherung fortbesteht.
            </p>

            <p>
              Bei der Verarbeitung von personenbezogenen Daten auf Grundlage von
              Art. 6 Abs. 1 lit. f DSGVO werden diese Daten so lange
              gespeichert, bis Sie Ihr Widerspruchsrecht nach Art. 21 Abs. 1
              DSGVO aus&uuml;ben, es sei denn, wir k&ouml;nnen zwingende
              schutzw&uuml;rdige Gr&uuml;nde f&uuml;r die Verarbeitung
              nachweisen, die Ihre Interessen, Rechte und Freiheiten
              &uuml;berwiegen, oder die Verarbeitung dient der Geltendmachung,
              Aus&uuml;bung oder Verteidigung von Rechtsanspr&uuml;chen.
            </p>

            <p>
              Bei der Verarbeitung von personenbezogenen Daten zum Zwecke der
              Direktwerbung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO werden
              diese Daten so lange gespeichert, bis Sie Ihr Widerspruchsrecht
              nach Art. 21 Abs. 2 DSGVO aus&uuml;ben.
            </p>

            <p>
              Sofern sich aus den sonstigen Informationen dieser Erkl&auml;rung
              &uuml;ber spezifische Verarbeitungssituationen nichts anderes
              ergibt, werden gespeicherte personenbezogene Daten im &Uuml;brigen
              dann gel&ouml;scht, wenn sie f&uuml;r die Zwecke, f&uuml;r die sie
              erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr
              notwendig sind.
            </p>
            <div style={{ height: "5%" }}></div>
          </div>
        ) : (
          <div className="content">
            <h1>Privacy Policy</h1>

            <h2>
              1) Introduction and Contact Details of the Responsible Party
            </h2>

            <p>
              <b>1.1</b>&nbsp;We are pleased that you are visiting our website
              and thank you for your interest. Below we inform you about how we
              handle your personal data when using our website. Personal data
              are all data that can personally identify you.
            </p>

            <p>
              <b>1.2</b>&nbsp;The party responsible for data processing on this
              website in the sense of the General Data Protection Regulation
              (GDPR) is Norman Azar, GliaTech, Großgartacherstr. 90, 74080
              Heilbronn, Germany, Tel.: +491792235717, E-Mail:
              admin@gliatech.net. The responsible party for the processing of
              personal data is the natural or legal person who, alone or jointly
              with others, decides on the purposes and means of processing
              personal data.
            </p>

            <h2>2) Data Collection When Visiting Our Website</h2>

            <p>
              <b>2.1</b>&nbsp;When using our website for informational purposes
              only, i.e., if you do not register or transmit information to us
              in any other way, we only collect data that your browser transmits
              to the server (so-called "server log files"). When you visit our
              website, we collect the following data, which are technically
              necessary for us to display the website:
            </p>

            <ul>
              <li>Our visited website</li>
              <li>Date and time of access</li>
              <li>Amount of data sent in bytes</li>
              <li>Source/reference from which you came to the page</li>
              <li>Browser used</li>
              <li>Operating system used</li>
              <li>IP address used (possibly in anonymized form)</li>
            </ul>

            <p>
              The processing is carried out in accordance with Art. 6 (1) lit. f
              GDPR based on our legitimate interest in improving the stability
              and functionality of our website. No transfer or further use of
              the data takes place. However, we reserve the right to review the
              server log files retrospectively if there are specific indications
              of illegal use.
            </p>

            <p>
              <b>2.2</b>&nbsp;This website uses an SSL or TLS encryption for
              security reasons and to protect the transmission of personal data
              and other confidential content (e.g., orders or inquiries to the
              responsible party). You can recognize an encrypted connection by
              the "https://" string and the lock symbol in your browser bar.
            </p>

            <h2>3) Hosting & Content Delivery Network</h2>

            <p>Google Cloud CDN</p>

            <p>
              We use a Content Delivery Network from the following provider:
              Google Ireland Limited, Gordon House, 4 Barrow St, Dublin, D04
              E5W5, Ireland
            </p>

            <p>
              This service allows us to deliver large media files such as
              graphics, page content, or scripts more quickly via a network of
              regionally distributed servers. The processing is carried out to
              safeguard our legitimate interest in improving the stability and
              functionality of our website in accordance with Art. 6 (1) lit. f
              GDPR.
            </p>

            <p>Data may also be transmitted to: Google LLC, USA</p>

            <p>
              We have signed a data processing agreement with the provider,
              ensuring the protection of our site visitors' data and prohibiting
              unauthorized disclosure to third parties.
            </p>

            <p>
              For data transfers to the USA, the provider has joined the EU-US
              Data Privacy Framework, which ensures compliance with the European
              level of data protection based on an adequacy decision of the
              European Commission.
            </p>

            <h2>4) Cookies</h2>

            <p>
              To make the visit to our website more attractive and to enable the
              use of certain features, we use cookies, small text files that are
              stored on your device. Some cookies are automatically deleted
              after closing the browser (so-called "session cookies"), while
              others remain on your device for a longer period and enable the
              storage of page settings (so-called "persistent cookies"). In the
              latter case, you can find the duration of storage in the cookie
              settings of your web browser.
            </p>

            <p>
              If personal data is processed through cookies used by us, the
              processing is carried out in accordance with Art. 6 (1) lit. b
              GDPR either for the performance of the contract, in accordance
              with Art. 6 (1) lit. a GDPR in the case of consent, or in
              accordance with Art. 6 (1) lit. f GDPR for the protection of our
              legitimate interests in ensuring the best possible functionality
              of the website and a customer-friendly and effective design of the
              site visit.
            </p>

            <p>
              You can configure your browser to inform you when cookies are set
              and to decide individually whether to accept them or exclude the
              acceptance of cookies in certain cases or in general.
            </p>

            <p>
              Please note that if you do not accept cookies, the functionality
              of our website may be limited.
            </p>

            <h2>5) Contacting Us</h2>

            <p>
              When contacting us (e.g., via contact form or email), personal
              data is collected. The data collected in the case of using a
              contact form can be found in the respective contact form. These
              data will be used exclusively for the purpose of answering your
              inquiry or for contacting you and the associated technical
              administration.
            </p>

            <p>
              The legal basis for processing this data is our legitimate
              interest in answering your inquiry according to Art. 6 (1) lit. f
              GDPR. If your contact is aimed at concluding a contract, then an
              additional legal basis for the processing is Art. 6 (1) lit. b
              GDPR. Your data will be deleted after your inquiry has been
              processed, provided that the circumstances indicate that the
              matter has been conclusively clarified and no legal retention
              obligations exist.
            </p>

            <h2>6) Use of Customer Data for Direct Marketing</h2>

            <p>Newsletter Subscription</p>

            <p>
              If you subscribe to our email newsletter, we will regularly send
              you information about our offers. The only mandatory information
              for sending the newsletter is your email address. Providing
              additional data is voluntary and will be used to address you
              personally. For sending the newsletter, we use the so-called
              double opt-in procedure. This means that we will only send you a
              newsletter after you have explicitly confirmed that you agree to
              receive the newsletter. We will send you a confirmation email,
              asking you to confirm by clicking a link that you want to receive
              the newsletter.
            </p>

            <p>
              By activating the confirmation link, you give us your consent for
              the use of your personal data according to Art. 6 (1) lit. a GDPR.
              When subscribing to the newsletter, we store the IP address
              registered by the Internet Service Provider (ISP) as well as the
              date and time of the subscription, in order to trace possible
              misuse of your email address at a later time. The data we collect
              when subscribing to the newsletter will only be used for the
              purpose of promotional communication via the newsletter. You can
              unsubscribe from the newsletter at any time via the link provided
              in the newsletter or by sending an appropriate message to the
              responsible party mentioned above. After unsubscribing, your email
              address will be immediately deleted from our newsletter
              distribution list, unless you have explicitly consented to further
              use of your data or we reserve the right to further use your data,
              which is legally permissible and about which we inform you in this
              statement.
            </p>

            <h2>7) Rights of the Data Subject</h2>

            <p>
              <b>7.1</b>&nbsp;The applicable data protection law grants you the
              following rights regarding the processing of your personal data by
              the responsible party (rights of access and intervention),
              referring to the legal basis for their exercise as indicated:
            </p>

            <ul>
              <li>Right of access according to Art. 15 GDPR;</li>
              <li>Right to rectification according to Art. 16 GDPR;</li>
              <li>Right to deletion according to Art. 17 GDPR;</li>
              <li>Right to restrict processing according to Art. 18 GDPR;</li>
              <li>Right to notification according to Art. 19 GDPR;</li>
              <li>Right to data portability according to Art. 20 GDPR;</li>
              <li>Right to withdraw consent according to Art. 7 (3) GDPR;</li>
              <li>Right to lodge a complaint according to Art. 77 GDPR.</li>
            </ul>

            <p>
              <b>7.2</b>&nbsp;RIGHT TO OBJECT
            </p>

            <p>
              If we process your personal data as part of a legitimate interest,
              you have the right to object to this processing at any time on
              grounds relating to your particular situation, with effect for the
              future.
            </p>

            <p>
              If you exercise your right to object, we will stop processing the
              affected data. Further processing may be allowed if we can
              demonstrate compelling legitimate grounds for the processing that
              override your interests, rights, and freedoms, or if the
              processing is necessary for the establishment, exercise, or
              defense of legal claims.
            </p>

            <p>
              If your personal data is processed for direct marketing purposes,
              you have the right to object at any time to the processing of your
              personal data for such marketing purposes. You can exercise the
              right to object as described above.
            </p>

            <p>
              If you exercise your right to object, we will stop processing the
              affected data for direct marketing purposes.
            </p>

            <h2>8) Duration of Storage of Personal Data</h2>

            <p>
              The duration of the storage of personal data is based on the
              respective legal basis, the purpose of processing, and, if
              applicable, the respective statutory retention period (e.g.,
              commercial and tax law retention periods).
            </p>

            <p>
              When processing personal data based on explicit consent according
              to Art. 6 (1) lit. a GDPR, the affected data will be stored until
              you withdraw your consent.
            </p>

            <p>
              If there are legal retention periods for data processed in the
              context of legal or quasi-legal obligations based on Art. 6 (1)
              lit. b GDPR, these data will be routinely deleted after the
              retention periods have expired, unless they are still necessary
              for contract performance or initiation and/or we have a legitimate
              interest in further retention.
            </p>

            <p>
              When processing personal data based on Art. 6 (1) lit. f GDPR,
              this data will be stored until you exercise your right to object
              according to Art. 21 (1) GDPR, unless we can demonstrate
              compelling legitimate grounds for the processing that override
              your interests, rights, and freedoms, or the processing is
              necessary for the establishment, exercise, or defense of legal
              claims.
            </p>

            <p>
              When processing personal data for direct marketing purposes based
              on Art. 6 (1) lit. f GDPR, this data will be stored until you
              exercise your right to object according to Art. 21 (2) GDPR.
            </p>

            <p>
              Unless otherwise specified in this declaration regarding specific
              processing situations, stored personal data will be deleted when
              they are no longer necessary for the purposes for which they were
              collected or otherwise processed.
            </p>
            <div style={{ height: "5%" }}></div>
          </div>
        )}
      </div>
    </>
  );
}

export default PrivacyPolicy;
